import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end flex-col scale-75 border rounded shadow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      icon: "pi pi-chevron-up",
      class: _normalizeClass([
        'btn-light scale-80 h-8',
        _ctx.index === 0 ? '!bg-gray-200 cursor-default' : '',
      ]),
      disabled: _ctx.index === 0,
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('onOrder', 'up')), ["prevent"]))
    }, null, 8, ["class", "disabled"]),
    _createVNode(_component_Button, {
      icon: "pi pi-chevron-down",
      class: _normalizeClass([
        'btn-light scale-80 h-8',
        _ctx.data === _ctx.allData?.slice(-1)[0] ? '!bg-gray-200 cursor-default' : '',
      ]),
      disabled: _ctx.data === _ctx.allData?.slice(-1)[0],
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('onOrder', 'down')), ["prevent"]))
    }, null, 8, ["class", "disabled"])
  ]))
}